import { api } from "./client";

export function listAlerts({ page = 1, unreadOnly = false, signal } = {}) {
  const query = new URLSearchParams({ page: String(page) });
  if (unreadOnly) query.set("unread_only", "true");
  return api(`/api/alerts?${query}`, { signal });
}

export function markAllAlertsSeen() {
  return api("/api/alerts/seen-all", { method: "POST" });
}

export function markAlertSeen(alertId) {
  return api(`/api/alerts/${alertId}/seen`, { method: "POST" });
}

export function markAlertUnseen(alertId) {
  return api(`/api/alerts/${alertId}/unseen`, { method: "POST" });
}

export function alertDetail(alertId, lang, { signal } = {}) {
  return api(`/api/alerts/${alertId}/detail?lang=${encodeURIComponent(lang)}`, { signal });
}
